import { nanoid } from 'nanoid';

const ONELOGINSEC = 'onelogin_security';

class OneloginUtil {
  getSec() {
    const sec = sessionStorage.getItem(ONELOGINSEC);
    return JSON.parse(sec);
  }

  initSec() {
    return sessionStorage.setItem(ONELOGINSEC, JSON.stringify({ state: nanoid(32), nonce: nanoid(32) }));
  }

  clearSec() {
    return sessionStorage.setItem(ONELOGINSEC, null);
  }
}

// follows singletons object of class
export default new OneloginUtil();
